export default {
  "content": "<path d=\"M30 10v4h-8v8h-4v-4H6v20h36V10H30zM14 34h-4V22h4v12zm8 0h-4v-8h4v8zm8 0h-4V18h4v16zm8 0h-4V14h4v20z\" fill=\"#ff00cb\"/>",
  "attrs": {
    "width": "48",
    "height": "48",
    "viewBox": "0 0 48 48",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};